import React, { useState } from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { baseRoute } from 'config/const';
import { ToolbarWrapper } from './style';

function Toolbar({ buttons, current, handleTab, sx = {}, bgc }) {
  const navigate = useNavigate();
  const defaultTab = (buttons || []).findIndex((btn) => btn.key === current);
  const [value, setValue] = useState(defaultTab);

  return (
    <ToolbarWrapper bgc={bgc} sx={sx}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={
          handleTab ||
          ((event, newValue) => {
            setValue(newValue);
            navigate(`${baseRoute}${buttons[newValue].path}`, {
              replace: true,
            });
          })
        }
        sx={{ backgroundColor: bgc }}
      >
        {buttons.map((btn) => (
          <BottomNavigationAction
            {...btn}
            sx={{ p: 0 }}
            key={`toolbar-${btn.key || btn.label}`}
            onClick={() => {
              if (typeof btn.onClick === 'function') btn.onClick(btn, navigate);
            }}
          />
        ))}
      </BottomNavigation>
    </ToolbarWrapper>
  );
}

Toolbar.propTypes = {
  buttons: PropTypes.array.isRequired,
  current: PropTypes.string,
  handleTab: PropTypes.func,
  sx: PropTypes.object,
  bgc: PropTypes.string,
};

export default Toolbar;
